import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, booleanAttribute } from '@angular/core';

@Component({
    selector: 'cs-container-description',
    templateUrl: './container-description.component.html',
    styleUrl: './container-description.component.scss',
    imports: [NgClass],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContainerDescriptionComponent {
    @Input() iconClass = '';
    @Input() subtitleClass = '';
    @Input() titleText = '';
    @Input() subtitleText = '';
    @Input() titleInlineStyle = '';
    @Input() subtitleInlineStyle = '';
    @Input({ transform: booleanAttribute }) isLegacy = false;
}
